import React from 'react';
import { List, Button, Tooltip } from 'antd';
import { CloseOutlined, EditOutlined, FontSizeOutlined } from '@ant-design/icons'
import { getValues  } from '../../virtuoso/helper';

/** Отображение краткой информации о распространении с сылкой на рспросранение */
export const AssetDistributionListItem = ({distribution, lang, onClick, canDeleted, onDelete, onSelectOperation = f=>f}) => {
  const IRI = distribution.object.value;
  const header = (distribution.values)? getValues("http://purl.org/dc/terms/title", lang, distribution.values):IRI;
  //const description = (distribution.values)? getValues("http://purl.org/dc/terms/description", lang, distribution.values):IRI;
  const description = "";
  const actions= (canDeleted)?
    [
      <span style={{
          padding: "0px",
          listStyle: "none",
          display: "flex",
          alignItems: "center",
          gap: "4px",
        }}>
        <Tooltip placement="top" title={"Удаление распространения"}>
          <Button size="small" icon={<CloseOutlined />} onClick={(e)=> onDelete(e, IRI, header)}/>
        </Tooltip>
        <Tooltip placement="top" title={"Редактирование свойств распространения"} style={{"display": "none"}}>
          <Button size="small" icon={<EditOutlined />} onClick={(e)=> onSelectOperation(e, IRI, "edit")} style={{"display": "none"}}/>
        </Tooltip>
        <Tooltip placement="top" title={"Перевод свойств распространения"}  style={{"display": "none"}}>
          <Button size="small" icon={<FontSizeOutlined />} onClick={(e)=> onSelectOperation(e, IRI, "translate")} style={{"display": "none"}}/>
        </Tooltip>
      </span>
    ]:[];
  return(
    <List.Item actions={actions} style={{"borderRadius": "0", "padding": "0px", "display": "flex", alignItems: "center"}}>
      <List.Item.Meta  style={{"width": "100%"}}
        title={
          (onClick?
            <Button type="link" block onClick={(e)=>onClick(e, IRI)}>
              <span className="csi_cat_title" style={{color: "#0b5fff"}}>{header}</span>
            </Button>
          :
          <span className="csi_cat_title" style={{}}>{header}</span>
          )
        }
        description={description}
      />
    </List.Item>
  )
}